/**
 * Resolves the denominator for a sample-enrichment progress bar from the two
 * counts the status endpoint reports: the requested `sampleSize` and
 * `totalProducts` (the products actually dispatched for the run).
 *
 * Neither alone is correct. `totalProducts` can echo the full scoring pool on
 * large catalogs (rendering "3 of 202,800"), while `sampleSize` overshoots when
 * the catalog holds fewer products than the sample asked for — a catalog of 8
 * against `sampleSize: 10` renders "0 of 10" and can never reach 100%. The
 * smaller of the two is the real ceiling in both cases. Either value is ignored
 * when absent or zero, so the bar still has a total mid-run before the backend
 * has populated both.
 */
export function resolveSampleTotal(
  totalProducts: number | null | undefined,
  sampleSize: number | null | undefined,
): number {
  const dispatched = totalProducts && totalProducts > 0 ? totalProducts : 0;
  const requested = sampleSize && sampleSize > 0 ? sampleSize : 0;
  if (dispatched > 0 && requested > 0) return Math.min(dispatched, requested);
  return dispatched || requested;
}
